import { Foreground } from '@front/sharedcomponents/Styles';
import { AlertMessageBoxType } from '@shared/utils/Interfaces/Screens/AlertMessageBox.types';
export function getAlertIconColor(type) {
    switch (type) {
        case AlertMessageBoxType.High:
            return Foreground.Negative;
        case AlertMessageBoxType.Medium:
            return Foreground.PrimaryData;
        case AlertMessageBoxType.Low:
            return Foreground.Positive;
    }
}
